import script from "./AdminServiceTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminServiceTableRow.vue?vue&type=script&setup=true&lang=js"

import "./AdminServiceTableRow.vue?vue&type=style&index=0&id=535c8dea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535c8dea"]])

export default __exports__